import React from 'react';
import './ConfigErrorMsg.css';

const ConfigErrorMsg = ({subject, body, cause = '', onSide = 'right'}) => {
  const styleClass = `configErrorMsg ${onSide}`;

  return (
    <div className={styleClass}>
      <div className='errMsgHeader'>
        {subject}
      </div>
      <div className='errMsgCause'>
        {cause !== '' ? cause : ''}
      </div>
      <div className='errMsgBody'>
        {body}
      </div>
      <div className='errMsgFooter'>
        Please fix or press Esc to revert changes
      </div>
    </div>
  );
};

export default ConfigErrorMsg;